import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/breadcrumb/br-shape-1.webp'
import _imports_1 from '../../assets/img/breadcrumb/br-shape-2.webp'


const _hoisted_1 = { class: "breadcrumb-wrap position-relative index-1" }
const _hoisted_2 = { class: "container text-center position-relative index-1" }
const _hoisted_3 = { class: "br-title fs-52 mb-15" }
const _hoisted_4 = { class: "br-menu list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Image",
        class: "br-shape-one position-absolute moveHorizontal sm-none"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_1,
        alt: "Image",
        class: "br-shape-two position-absolute bounce sm-none"
      }, null, -1)),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Home")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, _toDisplayString(_ctx.mainTitle), 1)
      ])
    ])
  ]))
}